import { InputNumber } from 'antd';
import React, { ReactElement } from 'react';

const CustomInputNumber = (props: any): ReactElement => {
  return (
    <div className="custom-input-number-container">
      {props.prefix && <span className="custom-input-number-prefix">{props.prefix}</span>}
      <InputNumber className={props.prefix ? 'custom-input-number' : ''} {...props} />
    </div>
  );
};

export default CustomInputNumber;
